<template>
	<div class="container">
		<van-empty image="error" description="用户身份获取失败" />
	</div>
</template>

<script>
export default {
	name: "error",
	data() {
		return {};
	}
};
</script>
